import {
  ELEMENT_BG_PALETTE,
  ELEMENT_COLOR_PALETTE,
  GREY_BG,
  GREY_BORDER,
} from "../../../constants/global.constants";

const EMPTY_ELEMENT_STYLE = {
  backgroundColor: GREY_BG,
  borderColor: GREY_BORDER,
};

const getNormalizedElementValue = (value) => {
  if (typeof value === "string") {
    const trimmedValue = value.trim();
    return trimmedValue.length > 0 ? trimmedValue : "";
  }

  return value || "";
};

export const getElementStyles = (elements = []) => {
  const elementList = Array.isArray(elements) ? elements : [];
  const paletteSize = ELEMENT_COLOR_PALETTE.length;
  let groupIndex = -1;
  let previousValue = "";

  return elementList.map((value) => {
    const normalizedValue = getNormalizedElementValue(value);

    if (!normalizedValue) {
      previousValue = "";
      return EMPTY_ELEMENT_STYLE;
    }

    if (normalizedValue !== previousValue) {
      groupIndex += 1;
      previousValue = normalizedValue;
    }

    const colorIndex = groupIndex % paletteSize;

    return {
      backgroundColor: ELEMENT_BG_PALETTE[colorIndex],
      borderColor: ELEMENT_COLOR_PALETTE[colorIndex],
    };
  });
};
